import React from "react";
import type { PaginationProps } from "antd";
import { Grid, Pagination as Paginate, Space } from "antd";
import { useTranslation } from "react-i18next";
import Text from "../base/Text";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

interface IPaginationProps extends PaginationProps {
  totalPage?: number;
}

const { useBreakpoint } = Grid;
const Pagination = ({ totalPage, ...props }: IPaginationProps) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const itemRender: PaginationProps["itemRender"] = (
    page,
    type,
    originalElement,
  ) => {
    page = props.current || 1;
    if (type === "prev") {
      return (
        <Space>
          <ArrowLeftOutlined
            style={{ color: page === 1 ? "rgba(0,0,0,.2)" : "#7e5435" }}
          />
          <Text
            label={screens.md ? t("previous") : ""}
            style={{ color: page === 1 ? "rgba(0,0,0,.2)" : "#7e5435" }}
          />
        </Space>
      );
    }
    if (type === "next") {
      return (
        <Space>
          <Text
            label={screens.md ? t("next") : ""}
            style={{
              color: page === totalPage ? "rgba(0,0,0,.2)" : "#7e5435",
            }}
          />
          <ArrowRightOutlined
            style={{
              color: page === totalPage ? "rgba(0,0,0,.2)" : "#7e5435",
            }}
          />
        </Space>
      );
    }
    return originalElement;
  };
  return (
    <Paginate
      {...props}
      itemRender={itemRender}
      responsive
      style={{
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    />
  );
};

export default Pagination;
